import {parseApiError} from '@common/http/errors/parsed-api-error';
import {queryClient} from '@common/http/query-client';
import {Button} from '@shadcn/button/button';
import {Empty} from '@shadcn/empty/empty';
import {Trans} from '@ui/i18n/trans';
import {CircleAlertIcon} from 'lucide-react';
import {useState} from 'react';

interface Props {
  error?: unknown;
}

export function PageErrorMessage({error}: Props) {
  const [isRetrying, setIsRetrying] = useState(false);
  const parsed = error ? parseApiError(error) : null;
  const handleRetry = async () => {
    setIsRetrying(true);
    await queryClient.removeQueries();
    setIsRetrying(false);
  };

  return (
    <Empty.Root>
      <Empty.Header>
        <Empty.Media>
          <CircleAlertIcon />
        </Empty.Media>
        <Empty.Title>
          <Trans message="There was an issue loading this page" />
        </Empty.Title>
        <Empty.Description>
          {parsed?.message && parsed.message !== 'An error occurred.' ? (
            parsed.status
              ? `${parsed.status}: ${parsed.message}`
              : parsed.message
          ) : (
            <Trans message="Please try again later" />
          )}
        </Empty.Description>
      </Empty.Header>
      <Empty.Content>
        <Button
          variant="outline"
          onClick={() => handleRetry()}
          disabled={isRetrying}
        >
          <Trans message="Retry" />
        </Button>
      </Empty.Content>
    </Empty.Root>
  );
}
